import { Box, Typography } from "@mui/material";
import LiveUpdateNotification from "./LiveUpdateNotification.js";

/** Coverage headline count, kept in one place so copy updates stay consistent. */
const SCHEDULE_COUNT = "60,000+";

/**
 * Signed-out hero at the top of the discovery feed: a headline, a one-line value
 * prop, and a frosted-glass push notification that morphs through the kinds of
 * live updates a followed calendar delivers.
 */
const DiscoveryHeroBanner = () => {
  return (
    <Box
      component="section"
      sx={{
        textAlign: "center",
        pt: { xs: 4, md: 6 },
        pb: { xs: 6, md: 8 },
        mb: { xs: 3, md: 4 },
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography
        component="h1"
        sx={{
          fontSize: { xs: "2rem", sm: "2.6rem", md: "3.4rem" },
          fontWeight: 800,
          letterSpacing: "-0.028em",
          lineHeight: 1.08,
          color: "text.primary",
          mx: "auto",
        }}
      >
        Everything you love,
        <br />
        on your calendar.
      </Typography>

      <Typography
        sx={{
          mt: { xs: 2, md: 2.5 },
          fontSize: { xs: "1rem", md: "1.15rem" },
          lineHeight: 1.6,
          color: "text.secondary",
          maxWidth: "540px",
          mx: "auto",
        }}
      >
        Follow with one click. Every new game, show, and episode lands on your
        calendar{" "}
        <Box component="span" sx={{ fontWeight: 700, color: "text.primary" }}>
          automatically
        </Box>
        , always up to date.
      </Typography>

      {/* Frosted-glass notification with drifting color orbs behind it */}
      <Box sx={{ mt: { xs: 4, md: 5 } }}>
        <LiveUpdateNotification />
      </Box>

      <Typography
        sx={{
          mt: { xs: 2.5, md: 3 },
          fontSize: { xs: "0.7rem", md: "0.75rem" },
          fontWeight: 800,
          letterSpacing: "0.16em",
          textTransform: "uppercase",
          color: "text.secondary",
        }}
      >
        From{" "}
        <Box component="span" sx={{ color: "text.primary" }}>
          {SCHEDULE_COUNT}
        </Box>{" "}
        teams, leagues, and shows
      </Typography>
    </Box>
  );
};

export default DiscoveryHeroBanner;
